function MovieRatingFormatter() {
    return function (rating) {
        return rating ? rating : "NR";
    };
}
MovieRatingFormatter.$inject = [];
angular
    .module("cstudioApp.filters")
    .filter("MovieRatingFormatter", MovieRatingFormatter);
